import { render, staticRenderFns } from "./Radio.vue?vue&type=template&id=55090d82&scoped=true&"
import script from "./radio.js?vue&type=script&lang=js&"
export * from "./radio.js?vue&type=script&lang=js&"
import style0 from "./Radio.vue?vue&type=style&index=0&id=55090d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55090d82",
  null
  
)

export default component.exports